// extracted by mini-css-extract-plugin
module.exports = {"course-ribbons":"course-card-ribbons_course-ribbons__ZLs29"};